/**
 * @flow
 */

import styled from 'react-emotion'
import Colors from '../../../themes/Colors'
import { mobile } from '../../../utils/mixins'
import { Typo30DarkGreyBlueTwoNBI } from '../../../themes/Fonts/Nort'

export const FutureSection = styled('section')`
  background-color: ${props =>
    props.invertTheme ? Colors.lightBlueTwo : Colors.white};
  padding-top: 60px;
  padding-bottom: 5em;
  ${mobile} {
    padding-top: 3.786em;
    font-size: 14px;
    padding-bottom: 4.286em;
  }
`

export const TitleContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Title = styled(Typo30DarkGreyBlueTwoNBI)`
  text-align: center;
  letter-spacing: 0.5px;
  line-height: normal;
  ${mobile} {
    font-size: 24px;
  }
  margin: 0;
`
export const TitleUnderLine = styled('div')`
  width: 100px;
  height: 2px;
  background-color: ${props =>
    props.invertTheme ? Colors.pumpkinOrange : Colors.ceruleanBlue};
  margin: auto;
  margin-top: 10px;
`



// WEBPACK FOOTER //
// ./src/components/TeamNew/FollowUsSection/styledComponents.js